import UpgradeHiro from "./UpgradeHiro";
export default UpgradeHiro;